import { create } from 'zustand';

import { MenuCategoryType } from '../../utils/common/types';
import { getCategoryName } from '../../utils/common/category';
import analytics from '../../services/analytics';

type Store = {
  selectedMenuCategoryType: MenuCategoryType;
  selectedMenuSubcategory: number;
  toggleMenuItem: (menuCategoryType: MenuCategoryType) => void;
  setMenuSelectedItem: (item: {
    selectedMenuSubcategory?: number;
    selectedMenuCategoryType: MenuCategoryType;
  }) => void;
  expandedMenuCategoryType: MenuCategoryType;
  resetMenu: () => void;
};

const initialState = {
  selectedMenuCategoryType: undefined,
  selectedMenuSubcategory: undefined,
  expandedMenuCategoryType: undefined,
};

const useMenuStore = create<Store>()((set, get) => {
  return {
    ...initialState,

    toggleMenuItem: (category) => {
      const { expandedMenuCategoryType } = get();
      const newExpandedMenuCategoryType =
        category === expandedMenuCategoryType ? undefined : category;

      set({
        expandedMenuCategoryType: newExpandedMenuCategoryType,
      });
      analytics.pageClick({
        page_path: window.location.pathname,
        category_name: category,
        action_type: `${category}_menu_category_open`,
      });
    },

    setMenuSelectedItem: ({ selectedMenuSubcategory, selectedMenuCategoryType }) => {
      if (selectedMenuCategoryType === MenuCategoryType.Create) {
        const { expandedMenuCategoryType } = get();

        set({
          selectedMenuCategoryType,
          expandedMenuCategoryType: expandedMenuCategoryType || MenuCategoryType.Generate,
          selectedMenuSubcategory: undefined,
        });

        analytics.pageClick({
          category_name: 'create',
          action_type: 'create_open',
          page_path: window.location.pathname,
          section_type: 'tab',
        });
        return;
      }

      const category = getCategoryName(selectedMenuSubcategory);
      analytics.pageClick({
        category_name: category,
        action_type: `${category}_open`,
        page_path: window.location.pathname,
        section_type: 'tab',
      });

      set({
        selectedMenuSubcategory,
        selectedMenuCategoryType,
        expandedMenuCategoryType: selectedMenuCategoryType,
      });
    },

    resetMenu: () => {
      set({
        selectedMenuCategoryType: undefined,
        selectedMenuSubcategory: undefined,
      });
    },
  };
});

export default useMenuStore;
